import { render, staticRenderFns } from "./OperationsGroup.vue?vue&type=template&id=f2710708&scoped=true"
import script from "./OperationsGroup.vue?vue&type=script&lang=js"
export * from "./OperationsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2710708",
  null
  
)

export default component.exports